import chameleon from '@chamaeleonidae/chmln';
import User from '@/types/user';

const CHAMELEON_FAST_URL = 'https://fast.chameleon.io/';

const init = () => {
  chameleon.init(import.meta.env.REACT_APP_CHAMELEON_TOKEN, { fastUrl: CHAMELEON_FAST_URL });
};

const identify = (user: User) => {
  chameleon.identify(user.id, {
    email: user.email,
    name: `${user.fname} ${user.lname}`,
    created: user.createdAt,
    env: import.meta.env.REACT_APP_ENV_NAME,
    groups: user.enterpriseGroups?.map(g => g.groupId),
    company: {
      uid: user.enterprise?._id,
      name: user.enterprise?.name,
    },
  });
};

export default {
  init,
  identify,
};
